let initialState = {
     message: ''
};

const ErrorReducer = (state=initialState, action) => {

  const payload = action.payload

  switch (action.type) {

    case 'SET_ERROR': {
      console.log('This is an error!')
      return {
       ...state,
        message : payload.message
      }
    }

    default:
      return state
  }
};

export const setError = (error) => ({ type: 'SET_ERROR', payload: { 'message' : error.message} })

export const handle_error = (error) => {
  return async (dispatch, getState) => {
    // Notify admin ???
    dispatch(setError(error))
}
};


export default ErrorReducer;
